(function () {
  const KEY = 'wishlist_v1';
  const get = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const save = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} };
  const drawer = () => document.getElementById('wl-drawer');
  const isOpen = () => drawer().classList.contains('open');
  const TRASH = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>';

  function sync() {
    const l = get();
    document.querySelectorAll('[data-wl-handle]').forEach(b =>
      b.classList.toggle('active', l.includes(b.dataset.wlHandle)));
    document.querySelectorAll('[data-wl-count]').forEach(c => {
      c.textContent = l.length;
      c.hidden = !l.length;
    });
  }

  function toggle(h) {
    let l = get();
    l = l.includes(h) ? l.filter(x => x !== h) : [...l, h];
    save(l);
    sync();
    if (isOpen()) render();
  }

  function img(url) {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=200';
  }

  function price(c) {
    return 'Rs.' + Math.round(c / 100).toLocaleString('en-US');
  }

  async function render() {
    const box = document.getElementById('wl-list');
    const l = get();
    if (!l.length) {
      box.innerHTML = '<p class="wl-empty">Aap ki wishlist abhi khali hai.</p>';
      return;
    }
    box.innerHTML = '<p class="wl-empty">Loading...</p>';
    const items = await Promise.all(l.map(h =>
      fetch('/products/' + h + '.js').then(r => r.ok ? r.json() : null).catch(() => null)));
    const html = items.filter(Boolean).map(p => `
      <div class="wl-item">
        <a class="wl-thumb" href="${p.url}"><img src="${img(p.featured_image)}" alt=""></a>
        <div class="wl-info">
          <a class="wl-title" href="${p.url}">${p.title}</a>
          <div class="wl-price">${price(p.price)}</div>
          <a class="wl-view" href="${p.url}">View product</a>
        </div>
        <button type="button" class="wl-trash" data-wl-remove="${p.handle}" aria-label="Remove">${TRASH}</button>
      </div>`).join('');
    box.innerHTML = html || '<p class="wl-empty">Aap ki wishlist abhi khali hai.</p>';
  }

  function openDrawer() {
    drawer().classList.add('open');
    document.body.classList.add('wl-lock');
    render();
  }
  function closeDrawer() {
    drawer().classList.remove('open');
    document.body.classList.remove('wl-lock');
  }

  document.addEventListener('click', (e) => {
    const heart = e.target.closest('[data-wl-handle]');
    if (heart) { e.preventDefault(); e.stopPropagation(); toggle(heart.dataset.wlHandle); return; }
    if (e.target.closest('[data-wl-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-wl-close]')) { closeDrawer(); return; }
    const rm = e.target.closest('[data-wl-remove]');
    if (rm) toggle(rm.dataset.wlRemove);
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('storage', sync);
})();